import { ZIO } from "@mxt/zio"
import { Maybe } from "@mxt/zio/codec"
import { POApi } from "@pulseops/common"
import { pipe } from 'fp-ts/lib/function'
import * as t from 'io-ts'

export namespace ACMetricHistoryDetailService {
  export type MetricHistoryDetailInfo = {
    requestID: string
    status: string
    type: string
    creator: string
    requestedDate: string
    approver: string
    approvedDate: string
    groupMetrics: string
    metricName: string
    value: string
    description: string
    oldOperator: string
    newOperator: string
    oldOperatorValue: string
    newOperatorValue: string
    oldRAGScore: string
    newRAGScore: string
    oldMultiplier: string
    newMultiplier: string
  }

  export const ACMetricHistoryDetailRequest = t.type({
    start: t.number,
    size: t.number,
    orders: t.array(t.string),
    sort: Maybe(t.string),
    status: t.string,
    createdBy: t.string,
    // groupMetrics: Maybe(t.string),
    groupId: Maybe(t.string),
    fromDate: t.string,
    toDate: t.string,
    isPaginate: t.boolean

  })

  export const ACMetricHistoryDetailResponse = t.type({
    id: t.string,
    requestId: t.number,
    metricCode: t.string,
    status: t.string,
    type: Maybe(t.string),
    oldMetric: t.type({
      id: t.string,
      metricCode: t.string,
      groupMetrics: t.string,
      metricName: t.string,
      value: t.string,
      method: t.string,
      description: t.string,
      priority: t.string,
      operator: t.string,
      operatorValue: t.string,
      type: t.string,
      ragThreshold: t.string,
      multiplier: t.string,
      visible: t.boolean
    }),
    newOperator: t.string,
    newOperatorValue: t.string,
    newRagThreshold: t.string,
    newMultiplier: t.string,
    approvedDate: Maybe(t.string),
    approver: Maybe(t.string),
    createdAt: t.string,
    createdBy: t.string,
    updatedAt: t.string,
    updatedBy: t.string,
  })

  export type ACMetricHistoryDetailRequest = t.OutputOf<typeof ACMetricHistoryDetailRequest>
  export type ACMetricHistoryDetailResponse = t.OutputOf<typeof ACMetricHistoryDetailResponse>

  export const getACMetricHistoryDetailList = (body: ACMetricHistoryDetailRequest) => pipe(
    POApi.internalPost(`internal/administration-rest/bsc/search-histories`)(t.type({
      total: t.number,
      start: t.number,
      size: t.number,
      data: t.array(ACMetricHistoryDetailResponse)
    }))(body),
    ZIO.map((response) => {
      return response
    })
  )
}